import { app } from '../../../../../app';
import { Controller } from './sms-users.controller';

app.component('companyUserDirectoriesSaaspassUsersSmsUsers', {
    bindings: {
        smsUsers: '<',
		labels: '<',
        numberOfUsers: '<',
    },
    controller: Controller,
    templateUrl: require('./sms-users.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/sms-users/sms-users.component.js